import { useState, useEffect } from 'react';

export default function Gallery() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/3b694e96ab09cae845aa7425e4769004.jpeg',
    'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/1f313d2619c314163a32654694b23b31.jpeg',
    'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/c1dbefdad556beb3ba2bf521799d4ad7.jpeg',
    'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/3bc242a0d90dfbbdac88856884d6d418.jpeg',
    'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/1663c2e92503c0043c597ac46d0ce37f.jpeg',
    'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/4053862424da68b7a336642c8de2853f.jpeg',
    'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/3259618a0f4b6c8d2354253e7461b658.jpeg',
    'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/bde454667f9e35e50d893a878aea1e33.jpeg'
  ];

  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const handleImageClick = (index: number) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
  };

  useEffect(() => {
    if (!isAutoPlaying) return;
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [isAutoPlaying]);

  // Duplicar as imagens para criar o efeito de loop infinito
  const duplicatedImages = [...images, ...images, ...images];

  return (
    <section className="py-20 bg-gradient-to-b from-red-50 to-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Galeria de Fotos</h2>
          <p className="text-lg text-gray-600">Conheça nossos espaços e atividades</p>
        </div>

        <div className="relative mb-12">
          <div className="overflow-hidden rounded-3xl shadow-2xl">
            <div className="relative h-[500px]">
              <img 
                src={images[currentIndex]}
                alt={`Galeria The Joy School Paulínia ${currentIndex + 1}`}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              
              <div className="absolute bottom-6 left-1/2 -translate-x-1/2 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full">
                <span className="text-sm font-medium text-gray-800">
                  {currentIndex + 1} / {images.length}
                </span>
              </div>
            </div>
          </div>

          <button 
            onClick={prevSlide}
            className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/90 hover:bg-white rounded-full shadow-lg transition-all hover:scale-110 cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-2xl text-gray-800"></i>
          </button>

          <button 
            onClick={nextSlide}
            className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/90 hover:bg-white rounded-full shadow-lg transition-all hover:scale-110 cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-2xl text-gray-800"></i>
          </button>

          <button
            onClick={() => setIsAutoPlaying(!isAutoPlaying)}
            className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-white/90 hover:bg-white rounded-full shadow-lg transition-all hover:scale-110 cursor-pointer"
          >
            <i className={`${isAutoPlaying ? 'ri-pause-line' : 'ri-play-line'} text-xl text-gray-800`}></i>
          </button>
        </div>

        <div className="overflow-hidden">
          <div className="animate-scroll-gallery flex gap-4">
            {duplicatedImages.map((img, index) => (
              <div 
                key={index} 
                onClick={() => handleImageClick(index % images.length)}
                className={`relative overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all cursor-pointer group flex-shrink-0 ${
                  (index % images.length) === currentIndex ? 'ring-4 ring-red-500' : ''
                }`}
                style={{ width: '280px' }}
              >
                <div className="aspect-[4/3]">
                  <img 
                    src={img}
                    alt={`Galeria ${(index % images.length) + 1}`}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                {(index % images.length) === currentIndex && (
                  <div className="absolute inset-0 bg-red-500/20 flex items-center justify-center">
                    <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg">
                      <i className="ri-eye-line text-2xl text-red-500"></i>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
